import { render } from "./DepositProof.vue?vue&type=template&id=90ffc62a"
import script from "./DepositProof.vue?vue&type=script&lang=js"
export * from "./DepositProof.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__